import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import useBrowserMode from "../../../hooks/useBrowserMode";
import useHomeLinkMode from "../../../hooks/useHomeLinkMode";
import useLocaleMode from "../../../hooks/useLocaleMode";
import celularIcon from "./../../../assets/images/icon-celular.svg";
import logoFamilia from "./../../../assets/images/logo-grupo-familia.svg";
import "./footer.scss";

const Footer = props => {

  const { locale } = useLocaleMode();
  const { homeLink } = useHomeLinkMode();
  const { isBrowser } = useBrowserMode();

  const result = useStaticQuery(graphql`
    query InfoFooter {
      allContentfulTenaHome {
        nodes {
          footerInformacionAdicionalDos
          footerInformacionAdicionalTres
          footerInformacionAdicionalUno
          footerNumeroLineaDeAtencion
          footerRedireccionDos
          footerRedireccionTres
          footerTituloLineaDeAtencion
          footerRedireccionUno
          footerLineaDeAtencionRegistro
          node_locale
        }
      }
    }
  `);

  const footerInfo =
    result && isBrowser &&
    result.allContentfulTenaHome.nodes.filter(
      node => node.node_locale === locale
    )[0];

  const {
    footerTituloLineaDeAtencion,
    footerNumeroLineaDeAtencion,
    footerInformacionAdicionalUno,
    footerInformacionAdicionalDos,
    footerInformacionAdicionalTres,
    footerRedireccionDos,
    footerRedireccionTres,
    footerRedireccionUno,
    footerLineaDeAtencionRegistro
  } = footerInfo;

  return (
    <footer className={`f-footer-wrapper ${(props.isFullPage && !props.isMobile) ? 'f-footer-wrapper--fullpage' : ''}`}>
      {
        footerInfo &&
          props.isFullPage ?
          <div className="f-footer-info-container">
              <div className="f-phone-info-wrapper">
                {locale !== "es-BO" ? (
                  <>
                    <img src={celularIcon} alt="imagen de linea de atencion" />
                    <div>
                      <p>{props.isMobile ? footerTituloLineaDeAtencion : footerLineaDeAtencionRegistro}</p>
                      <a href={`tel://${footerNumeroLineaDeAtencion}`} className="f-btn-nav-type" rel="nofollow">
                        {footerNumeroLineaDeAtencion}.
                    </a>
                    </div>
                  </>
                ) : null}
              </div>
          </div>
          :
          <>
            <div className="f-footer-info-container">
              <div className="f-phone-info-wrapper">
                {locale !== "es-BO" ? (
                  <>
                    <img src={celularIcon} alt="imagen de linea de atencion" />
                    <div>
                      <p>{footerTituloLineaDeAtencion}</p>
                      <a href={`tel://${footerNumeroLineaDeAtencion}`} className="f-btn-nav-type" rel="nofollow">
                        {footerNumeroLineaDeAtencion}.
                    </a>
                    </div>
                  </>
                ) : null}
              </div>

              {!props.isMobile && footerInfo && (
                <ul>
                  <li>
                    <a
                      className="f-footer-nav-link"
                      title={footerInformacionAdicionalUno}
                      href={homeLink + footerRedireccionUno}
                    >
                      {footerInformacionAdicionalUno}
                    </a>
                  </li>
                  <li>
                    <a
                      className="f-footer-nav-link"
                      title={footerInformacionAdicionalDos}
                      href={homeLink + footerRedireccionDos}
                    >
                      {footerInformacionAdicionalDos}
                    </a>
                  </li>
                  <li>
                    <a
                      className="f-footer-nav-link"
                      title={footerInformacionAdicionalTres}
                      href={homeLink + footerRedireccionTres}
                    >
                      {footerInformacionAdicionalTres}
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div className="f-brand-logo">
              <div className="f-brand-container">
                <img src={logoFamilia} alt="Logo Grupo Familia" />
                <small>© 2020 Todos los derechos reservados</small>
              </div>
            </div>
          </>
      }
    </footer>
  )
};

export default Footer;